// #181 Ato 2a — fonte ÚNICA da regra "ramo do 6M tem conteúdo?".
// Usado por todas as superfícies de render (tela / modal v2.0 / PDF) pra
// ESCONDER ramos do Ishikawa sem conteúdo real (vazio ou marcador de
// não-aplicabilidade tipo "Sem influência observável"). Tira o "box vazio"
// que num serviço (contábil etc.) parece checklist de fábrica.
//
// Render-only: NÃO apaga o dado. Se uma reanálise/edição preencher o ramo com
// conteúdo real, ele deixa de casar com "vazio" e volta a aparecer sozinho.
export function ramo6MTemConteudo(value) {
  if (!value) return false;
  const t = String(value).trim().toLowerCase();
  if (!t) return false;
  if (/^sem influ[eê]ncia/.test(t)) return false;       // "Sem influência observável..."
  if (/^n[aã]o se aplica/.test(t)) return false;
  if (/^n[aã]o aplic[aá]vel/.test(t)) return false;
  if (['n/a', 'na', '-', '—', 'nenhuma', 'nenhum'].includes(t)) return false;
  return true;
}
